/* eslint-disable import/no-cycle */
import LoadingModel from '@/utils/store/LoadingModel'
import User from '@/store/models/user/User'
import Collection from '@/store/models/collections/Collection'
import { MemberRole } from '@/utils/permissions/roles'

export const INVITE_STATUS = {
  pending: 0,
  accepted: 1,
  declined: 2,
}

class CollectionMember extends LoadingModel {
  static entity = 'collectionmembers'

  static fields() {
    return {
      ...super.fields(),
      userId: this.string(),
      invitedById: this.string(),
      collectionId: this.string(),
      email: this.string(),
      status: this.number(),
      role: this.attr(null),
      isOwner: this.boolean(),
      subCollectionIds: this.attr([]),
      // relationships
      user: this.belongsTo(User, 'userId'),
      invitedBy: this.belongsTo(User, 'invitedById'),
      collection: this.belongsTo(Collection, 'collectionId'),
    }
  }

  get isAdmin() {
    return this.role === MemberRole.ADMIN
  }

  get isEditor() {
    return this.role === MemberRole.EDITOR
  }
}

export default CollectionMember
